module.exports = __webpack_public_path__ + "static/media/dijia.f450f1c2.png";